export function hostnameFromUrl(url?: string | null): string | undefined {
  if (!url) return undefined
  try {
    const normalized = url.startsWith('http') ? url : `http://${url}`
    return new URL(normalized).hostname
  }
  catch {
    return undefined
  }
}

export function collectImageDomains(...urls: Array<string | undefined | null>): string[] {
  return [...new Set(urls.map(hostnameFromUrl).filter(Boolean) as string[])]
}

export function isRasterImageUrl(url?: string | null): boolean {
  if (!url) return false
  const normalized = url.split('?')[0]?.toLowerCase() ?? ''
  if (normalized.startsWith('data:')) return false
  return !normalized.endsWith('.svg')
}
